import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import upload_icon from "../../../assets/img/upload_icoon.svg";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import { ADMIN_ALL_CMS, ADMIN_ALL_CMS_UPDATE, ADMIN_CMS_IMAGE_UPLOAD_AWS  } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import Loading from "react-fullscreen-loading";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the 
import { createShortNameFile, errorMessageCreate } from "../../../util/custom";

const MySwal = withReactContent(Swal);


const AdminService = () => {
 const type = "services";
 const [id, setId] = useState(null);

 const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

   const [image, setImage] = useState('');

  const [formData, setFormData] = useState({
    type: null,
    content: null,
    image: null
  });

  React.useEffect(() => {
      getData();
    },[]
  );

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", `${ADMIN_ALL_CMS}/${type}`);
      if (response.res.status == 200) {
        console.log(response.res?.data?.data);
        let apiData = response.res?.data?.data;
        setId(apiData?.id);
        setImage(apiData?.image);
        setFormData((prev) => ({
          ...prev,
        //   name: apiData?.name || null,
        //   price: apiData?.price || null,
        //   number_of_reports: apiData?.number_of_reports || null,
          content: apiData?.content || null,
          image: apiData?.image || null,
          type: apiData?.type || null
        }));

        //   setPrmoptsList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

 
 

  const validateData = (data) => {
    const errors = {};

  if (!data.content || data.content.trim() === '') {
    errors.content = "Content is required.";
  }

  if (!data.image || data.image.trim() === '') {
    errors.image = "Image is required.";
  }

    return errors;
  };
  const saveData = async () => {
    console.log(image);
    try {
      const errors = validateData(formData); // Replace `Data` with your state variable
      
      if (Object.keys(errors).length > 0) {
        const firstError = Object.values(errors)[0]; // Get the first error message
        // toast.error(firstError, { position: toast.POSITION.TOP_RIGHT });
        showToast("error", firstError);

        return;
      }
      console.log(formData);

      //   return;
       let url = `${ADMIN_ALL_CMS_UPDATE}/${id}`; 
      let method = "PATCH";
      
    //   if (id) {        
    //     url = `${ADMIN_ABOUT}/${id}`;     

    //     method="PUT";
    //   }
      setIsLoading(true);

      formData.image = image;
     
      const response = await CallWithAuth(method, url, formData);
      console.log("response", response);

      if (response.res.status == 200 || response.res.status == 201) {
        showToast("success", response.res.data.message);
        
      } else {
        if (Array.isArray(response.res.data.message)) {
          showToast("error", response.res.data.message[0]);
        } else {
          showToast("error", response.res.data.message);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);

      setIsLoading(false);
    }
  };



 const handleChangeImageFile = async (e) => {
        setIsLoading(true);

        try {
            const { files } = e.target;
            const file = files[0];
            const formdata = new FormData();
            formdata.append("file", file);
            const body = formdata;
            const response = await CallWithAuth("POST", ADMIN_CMS_IMAGE_UPLOAD_AWS, body);
            let message = errorMessageCreate("Something went wrong!");

            if (response?.res?.status === 200 || 201) {
                showToast("success", "Image uploaded successfully.");
                setImage(response?.res?.data?.file_url);
            } else {
                showToast("error", message);
            }
            setIsLoading(false);
        } catch (err) { }
        setIsLoading(false);
    }

  const handleDescriptionChange = (value) => {
  setFormData(prev => ({
    ...prev,
    content: value,
  }));
};


  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}

      <section class="create_account_block">
        <div class="site_container">
          <div class="create_account_form">

              {/* <div className="field_block">
              <label>Plan Name</label>
              <input
               type="text"
                name="name"
                value={formData?.name}
                onChange={handleNameChange}
                //   fieldName="background info"
                className="form-control"
              />
            </div> */}
            

            <div className="field_block">
              <label>Content</label>
               <ReactQuill 
                value={formData?.content} 
                onChange={handleDescriptionChange} 
                placeholder="Enter your content here..."
              />
             
            </div>

            <div
            className="field_block col-md-6"
            // onDrop={(e) => handleDropTestimonialImageFrom(e)}
            onragOver={(e) => e.preventDefault()}
        >

            <div className="upload_field">
                    <div className="title">
                        <label>Please upload the  image</label>{" "}
                    </div>

                    <div className="upload_ui">
                        <label className="upload_ui_label">
                            <input
                                type="file"
                                name="audio"
                                accept=".png, .jpg, .jpeg"  // Only allow image files
                                onChange={handleChangeImageFile}
                                style={{ display: "none" }} // Hide input element
                            />
                            <div className="ui_inner">
                                <img src={upload_icon} alt="Upload" />
                                <h5>Upload</h5>
                                <p>
                                    <span>Browse</span> to upload the file
                                </p>
                            </div>
                        </label>
                    </div>
                    {image && image != '' && (
                        <>
                            <div className="record_seesion_info">
                                <p className="sm_txt">
                                    <strong>
                                        {createShortNameFile(
                                            image
                                        )}
                                    </strong>
                                </p>
                                <a
                                    href={`${image}`} // Full URL for S3 file
                                    target="_blank" // Opens link in a new tab
                                    rel="noopener noreferrer" // Security best practice
                                    className="edit"
                                >
                                    <i className="fa-solid fa-eye"></i>
                                </a>
                            </div>
                        </>
                    )}

                </div>
            </div>

            <button onClick={saveData} className="button_save_prompts">
              Update
            </button>
          </div>
        </div>
      </section>
      
         <ToastContainer />
    </>
  );
 
};
export default AdminService;
